import {
  AREA_UNITS,
  AreaUnit,
  UNIT_SYMBOLS,
} from '@src/constants/measureUnits.ts';
import {CONVERSION_MAP} from '@src/utils/unitConversions.ts';
import formatNumber from './formatNumber.ts';

type FormatAreaOptions = Intl.NumberFormatOptions & {
  /** Append the unit symbol (e.g. "1.5 km²"). Defaults to true. */
  includeUnitSymbol?: boolean;
};

export const formatArea = (
  squareMeters: number,
  unit?: AreaUnit | string,
  {includeUnitSymbol = true, ...numberOptions}: FormatAreaOptions = {},
) => {
  const unitKey = (unit ?? AREA_UNITS.metric.m2) as string;
  const conversionFn = CONVERSION_MAP.area.fromSqm[unitKey] ?? (x => x);
  const unitSymbol = UNIT_SYMBOLS[unitKey] ?? unit;

  const value = formatNumber(conversionFn(squareMeters), {
    minimumFractionDigits: 4,
    maximumFractionDigits: 4,
    ...numberOptions,
  });
  return includeUnitSymbol ? `${value} ${unitSymbol}` : value;
};

export default formatArea;
